import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistCombineReducers } from 'redux-persist';
//import { persistStore as persistStore4, autoRehydrate } from 'redux-persist4';
import appEventHandler from '../modules/storeMountCheck';
import Raven from 'raven-js';
import createRavenMiddleware from 'raven-for-redux';

import localforage from 'localforage';

import logger from 'redux-logger';
import reducers from '../reducers/';
import rootSaga from '../sagas';
import { combineForms } from 'react-redux-form';
import form from '../reducers/form';
import { dsn } from '../components/Sentry';

const persistConfig = {
  key: 'root',
  storage: localforage,
  debug: true,
  blacklist: ['global', 'order', 'regist', 'inquiry', 'exam'],
};
if (process.env.NODE_ENV === 'production') {
  Raven.config(dsn).install();
}

export const history = createBrowserHistory({ basename: '/app' });
const initialState = {};
const reducer = persistCombineReducers(persistConfig, {
  ...reducers,
  forms: combineForms(form, 'forms'),
});
const sagaMiddleware = createSagaMiddleware();
let store;

//if (window.require) {
if (false) {
  /*
  store = createStore(
    connectRouter(history)(
      combineReducers({
        ...reducers,
        forms: combineForms(form, 'forms'),
      })
    ),
    initialState,
    compose(
      applyMiddleware(sagaMiddleware, routerMiddleware(history), logger),
      autoRehydrate()
    )
  );
  persistStore4(store, { storage: localforage, blacklist: ['global'] }, () => {
    console.log('autoRehydrate completed');
    appEventHandler.emitFinishRehydrateStore();
  });
  */
} else {
  if (process.env.NODE_ENV === 'production') {
    store = createStore(
      connectRouter(history)(reducer),
      initialState,
      compose(
        applyMiddleware(
          sagaMiddleware,
          routerMiddleware(history),
          createRavenMiddleware(Raven, {})
        )
      )
    );
  } else {
    store = createStore(
      connectRouter(history)(reducer),
      initialState,
      compose(
        applyMiddleware(sagaMiddleware, routerMiddleware(history), logger)
      )
    );
  }
}
sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);
export default store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js